export default import.meta.ROLLUP_FILE_URL_n3djTMNIRODKNkWuVgbHmQ;